import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function LoyaltyIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Loyalty</title>
      <g>
        <path d="M26.875 30.1946V54.0404H14.5813C11.5896 54.0404 9.16667 51.6175 9.16667 48.63V30.1946H26.875ZM50.8333 30.1946V48.63C50.8333 51.6175 48.4104 54.0404 45.4208 54.0404H33.125V30.1946H50.8333ZM38.3354 5.95C42.9375 5.95 46.6687 9.67916 46.6687 14.2833C46.6687 15.8729 46.1979 17.3479 45.4229 18.6125H51.9375C53.6292 18.6125 55 19.9833 55 21.675V23.8833C55 25.5771 53.6292 26.9458 51.9375 26.9458H50.8333V26.9479H9.16667V26.9458H8.0625C6.37083 26.9458 5 25.5771 5 23.8833V21.675C5 19.9833 6.37083 18.6125 8.0625 18.6125H14.5771C13.8021 17.3479 13.3313 15.8729 13.3313 14.2833C13.3313 9.67916 17.0625 5.95 21.6646 5.95C26.2375 5.95 29.9438 9.63541 29.9896 14.1979C29.9979 14.1979 30.0042 14.2021 30.0104 14.2021C30.0542 9.63541 33.7604 5.95 38.3354 5.95ZM38.3354 10.5667C36.2875 10.5667 34.6187 12.2312 34.6187 14.2833C34.6187 16.3312 36.2875 17.9979 38.3354 17.9979C40.3833 17.9979 42.0521 16.3312 42.0521 14.2833C42.0521 12.2312 40.3833 10.5667 38.3354 10.5667ZM21.6646 10.5667C19.6167 10.5667 17.95 12.2312 17.95 14.2833C17.95 16.3312 19.6167 17.9979 21.6646 17.9979C23.7146 17.9979 25.3813 16.3312 25.3813 14.2833C25.3813 12.2312 23.7146 10.5667 21.6646 10.5667Z" />
      </g>
    </SvgIcon>
  );
}

export default LoyaltyIcon;
